module.exports = __webpack_public_path__ + "static/fonts/Recta.2d7c78b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Recta.eot
// module id = 332
// module chunks = 0